export default __webpack_public_path__ + "static/media/dataforce_logo_white.7e1b6fed.png";